module.exports = __webpack_public_path__ + "static/media/document-completed-signing-icon.0d989436.svg";